<script setup lang="ts">
interface Props {
    number: number
}

const props = defineProps<Props>()
</script>

<template>
    <div class="-mr-10 flex items-center">
        <div
            class="flex h-[72px] items-center rounded-3xl bg-primary-400 pl-6 pr-16 text-desk-h3 text-surface-0 lg:h-full">
            {{ props.number }}
        </div>
        <div
            class="relative -left-10 flex h-[72px] w-full grow items-center rounded-3xl bg-surface-100 p-4 text-body-14 text-surface-800 md:p-6 md:text-body-16 lg:h-full">
            <slot />
        </div>
    </div>
</template>
